import { Filter } from '@/types/utilTypes'

export enum FormulaModelType {
    Value = 'Value',
    Field = 'Field',
    Operator = 'Operator',
    ConditionalOperator = 'ConditionalOperator',
    If = 'If'
}

export type FormulaModel = {
    id?: string,
    type: FormulaModelType,
    value: string,
    condition: FormulaModel[],
    then: FormulaModel[],
    else: FormulaModel[]
}

export type FormulaContainer = {
    formulas: FormulaModel[],
    id: string,
    fieldLabel: string
    page: string
}


export type AggregateFieldModel = {
    id: string,
    fieldLabel: string,
    page: string
    aggregateField: string,
    aggregateFunction: string,
    type: string,
    lastUpdated: string,
    lastUpdatedBy: string
}

export type AggregateFilter = {
    fieldLabel: string
    searchFilters: Filter[]
}


export enum FormulasInputContainer {
    Main = 'Main',
    If = 'If',
    Then = 'Then',
    Else = 'Else'
}